import { render, staticRenderFns } from "./PublicCollections.vue?vue&type=template&id=e207dd42&scoped=true&"
import script from "./PublicCollections.vue?vue&type=script&lang=js&"
export * from "./PublicCollections.vue?vue&type=script&lang=js&"
import style0 from "./PublicCollections.vue?vue&type=style&index=0&id=e207dd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e207dd42",
  null
  
)

export default component.exports